require('./cardsBoxHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
const { Link } = require('react-router-dom');

// @ utilities
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
// @ commons
const OKTag = require('components/commons/OKTag/OKTag');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');
// @ actions
const hireTravelPlusActions = require('actions/hireTravelPlus');
const switchTravelPlusActions = require('actions/cardTravel');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const CardsCreditBalanceBar = require('components/cards/cardsCreditBalanceBar/cardsCreditBalanceBar');
const { CardsBoxHeaderControlToggle } = require('./cardsBoxHeaderToggles/cardsBoxHeaderControlToggle');
const { CardsBoxHeaderTravelToggle } = require('./cardsBoxHeaderToggles/cardsBoxHeaderTravelToggle');
const CardsBoxHeaderTravelPlusToggle = require('./cardsBoxHeaderToggles/cardsBoxHeaderTravelPlusToggle');
const { LoadingSection } = require('commonsComponents/loadingSection');
const Card = require('components/cards/card/card.js');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const { CARD_CREDIT, CARD_ECARD, CARD_INTERVENTION_OWNER } = require('constants/index');
const { TRAVEL_PLUS_R42 } = require('constants/flagBasedFeatures');

// @ assets
const changePinIcon = require("assets/icons/change-pin-grey.svg");
const cardControl = require("assets/icons/card-control-europe-circle.png");

class CardsBoxHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.getButtonAreaClientWidth = this.getButtonAreaClientWidth.bind(this)
        this.buttonRef = React.createRef();
    }
    getCardLogo() {
        const { immCard, immCommercialAds, expanded } = this.props;

        const cardId = immCard.get('cardId');
        const linkToMovements = `/myprofile/cards/${cardId}/movements`;
        const isActive = immCard.get('active');
        const isOperative = immCard.get('isOperative');
        const onState = immCard.get('control');
        const cardBrand = immCard.get('brand');
        const typeCard = immCard.getIn(['contract', 'product']);
        const subTypeCard = immCard.getIn(['criteria', 'c1', 'subtipoproducto']);
        const standardCodeCard = immCard.getIn(['criteria', 'c1', 'estand']).slice(-3);
        const commercialCardId = `B.${typeCard}.${subTypeCard}.${standardCodeCard}`;
        const immCommercialCard = immCommercialAds.getIn(['byId', commercialCardId]);
        const hasCommercialCardLogo = immCommercialCard && immCommercialCard.getIn(['fieldImageMedium', 'url']);
        const cardNumber = !__CONTACT_CENTER__ && (
            <Card
                immCard={immCard}
                immCommercialAds={immCommercialAds}
                showOnlyNumber={true}
                isSmallSize={expanded}
            />
        );
        const cardLogoClass = classnames(
            'cards-box-header__card-logo',
            {
                'cards-box-header__card-logo--commercial': hasCommercialCardLogo,
                'cards-box-header__card-logo--collapsed': !expanded,
                'cards-box-header__card-logo--expanded': expanded,
                'cards-box-header__card-logo--opacity': !isOperative || !isActive || !onState
            }
        );
        let dataToRender;

        if (immCommercialAds.get('isFetching')) {
            dataToRender = <LoadingSection />;
        } else if (hasCommercialCardLogo) {
            const altValue = immCommercialCard.get('fieldAltText');
            const urlValue = immCommercialCard.getIn(['fieldImageMedium', 'url']);

            dataToRender = (
                <div className={cardLogoClass}>
                    <Link to={linkToMovements}>
                        <img className="cards-box-header__card-logo-img" alt={altValue} src={urlValue} />
                    </Link>
                    <WebappRender>
                        {cardNumber}
                    </WebappRender>
                </div>
            );
        } else {
            dataToRender = (
                <div className={cardLogoClass}>
                    <Link to={linkToMovements}>
                        <div className={`icon-desktop-${cardBrand}-small icon-desktop-card`} />
                    </Link>
                    <WebappRender>
                        {cardNumber}
                    </WebappRender>
                </div>
            )
        }

        return dataToRender;
    }

    getTagProps() {
        const { immCard } = this.props;

        let type;
        let emphasis = false;

        switch (immCard.get('status')) {
            case 'CANCELADA':
                type = 'disabled';
                emphasis = true
                break;
            case 'BAJA':
                type = 'pending';
                break;
            case 'BLOQUEADO':
            case 'BLOQUEADO Y CAN':
                type = 'warning';
                emphasis = true
                break;
            default:
                type = 'informative';
                emphasis = true
        }

        return { type, emphasis };
    }

    ccSubdivision3 = (expanded, cardNumber, iconBeneficiaries) => {

        return (
            <div className="row cards-box-header__subdivision3">
                <div>
                    <span className="cards-box-header__card-info--details">
                        {cardNumber}
                    </span>
                    {iconBeneficiaries}
                </div>
            </div>
        )
    }

    getButtonAreaClientWidth() {
        return (this.buttonRef && this.buttonRef.current && this.buttonRef.current.clientWidth || 200) + 16;
    }

    render() {
        const {
            cardIndex,
            expanded,
            hireTravelPlusCCWrapUpOffStart,
            hireTravelPlusCCWrapUpOnStart,
            immCard,
            immGlobalVariables,
            immSignaturePattern,
            immTravelPlus,
            immVariables,
            flagBasedFeatures,
            setCardTravelPlus,
            setTravelPlus,
            travelPlusReset,
        } = this.props;
        const cardId = immCard.get('cardId');
        const cardType = immCard.get('type');
        const titular = 'TITULAR'
        const cardNumber = (
            <span className="cards-box-header__card-info--details">
                <WebappRender>
                    {getLastNChars(immCard.get('number'), 4)}
                </WebappRender>
                <ContactCenterRender>
                    {immCard.get('number')}
                </ContactCenterRender>
            </span>
        );
         const brandTranslationKey = `cards-${cardType}`;
        const cardTypeSpan = (
            <FormattedText className="cards-box-header__card-type cards-box-header__card-type--expanded" value={brandTranslationKey} />
        );
        const isActive = immCard.get('active');
        const activateLink = `/myprofile/cards/${cardId}/activate`;
        const isCreditCard = cardType === CARD_CREDIT;
        const isOperative = immCard.get('isOperative');
        const isEcard = cardType === CARD_ECARD;
        const activated = immCard.getIn(['r42', 'activated']);
        const promotionDate = immCard.getIn(['r42', 'promotionDate']);
        const travelSwitchVisible = immCard.getIn(['r42', 'travelSwitchVisible']);
        const descIntervenciones = immCard.get('interventionType') === titular;
        const vip = immCard.getIn(['r42', 'vip']);
        const linkToMovements = `/myprofile/cards/${cardId}/movements`;
        const isViaT = immCard.get('isViaT');
        const onState = immCard.get('control');
        const plainAmountObject = getPlainAmountObject(immCard.get('limit'));
        const cardLogo = this.getCardLogo();
        const aliasLinkClasses = classnames(
            'cards-box-header__card-info--alias',
            {
                'cards-box-header__card-info--alias-is-link': isActive,
                'cards-box-header__card-info--alias-is-expanded': isActive && expanded
            }
        );
        const cardTitle = (
            <Link className={aliasLinkClasses} to={linkToMovements}>
                {immCard.getIn(['alias', 'current'])}
            </Link>
        );
        const changePinLink = `/myprofile/cards/${cardId}/request/pin`;
        const changePinButton = (!__CONTACT_CENTER__ && isActive && cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard })) && (

            <span>
                <OKLink extraClass="buttons-base cards-box-header__base-button-padding" to={changePinLink}>
                    <img src={changePinIcon} />
                </OKLink>
            </span>
        )
        const cardsBoxHeadersSubClassName = contactCenterClassName('cards-box-header__subdivision1-left-column col-xs-2', 'cards-box-header__icon-container')
        const cardLogoAndBrand = (
            <div className={cardsBoxHeadersSubClassName}>
                {cardLogo}
            </div>
        );

        let balanceContent, iconControl, controlButton, travelButton, switchCardButton, activateButton, iconBeneficiaries, headerTag, chargeButton, cardsBoxHeaderView;

        const composeHeaderTag = () => {
            if (isActive && !onState) {
                return (
                    <div className="cards-box-header__ok-tag">
                        <OKTag
                            content="cardsControl-offState"
                            type="informative"
                        />
                    </div>
                );
            }
        }

        if (immCard.get('status') === 'EN VIGOR') {
            if (!isActive) {
                if (!isViaT) {
                    activateButton = (
                        <div className="cards-box-header__activate-button pull-right">
                            <OKButton
                                className="cards-box-header__activate-button-button"
                                modifier="secondary"
                                size="small"
                                to={activateLink}
                            >
                                <FormattedText value="cards-activate" />
                            </OKButton>
                        </div>
                    );
                }
                if (isCreditCard) {
                    balanceContent = (
                        <div className="cards-box-header__bar-container">
                            <div className="cards-box-header__contract-limit">
                                <FormattedText value="cards-contractLimit" />
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    className="cards-box-header__contract-limit-amount"
                                    trimDecimals
                                    language={getLanguage()}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                            </div>
                        </div>
                    );
                }
            } else if (isCreditCard || isEcard) {
                const barContainerClassName = classnames([
                    'cards-box-header__bar-container',
                    { 'cards-box-header__bar-container--only-balance': !isCreditCard }
                ])

                balanceContent = (
                    <div className={barContainerClassName}>
                        <CardsCreditBalanceBar immCard={immCard} showTooltip={false} />
                    </div>
                );
            }
        } else {
            const { type, emphasis } = this.getTagProps();
            const tagContent = `card-status${immCard.get('status')}`;
            headerTag = <OKTag content={tagContent} type={type} emphasis={emphasis} />;
        }


        if (isActive) {
            if (isOperative) {
                if (!isViaT) {
                    if (immCard.get('isConfigurable') &&
                        flagBasedFeatures.get('card-control-enabled')) {
                        iconControl = (
                            <div className="cards-box-header__control-button">
                                <OKLink onClick={e => { e.stopPropagation() }} to={`/myprofile/cards/config/${immCard.get('cardId')}`}>
                                    <img src={cardControl} className="cards-box-header__control-button__icon" />
                                </OKLink>
                            </div>
                        );
                        controlButton = (
                            <OKTooltip
                                content={<FormattedText value="cards-cardControlToolTip" />}
                                offset={[0, -15]}
                                target={iconControl}
                                type="descriptive"
                            />
                        );
                    }

                    switchCardButton = (
                        <div className="cards-box-header__toggle-button">
                            <CardsBoxHeaderControlToggle immCard={immCard} immVariables={immVariables} cardIndex={cardIndex} />
                        </div>
                    );
                }
                if (travelSwitchVisible   ) {
                    travelButton = (
                        <div>
                            <CardsBoxHeaderTravelPlusToggle
                                forceVipBehavior={!flagBasedFeatures.get(TRAVEL_PLUS_R42)}
                                hireTravelPlusCCWrapUpOffStart={hireTravelPlusCCWrapUpOffStart}
                                hireTravelPlusCCWrapUpOnStart={hireTravelPlusCCWrapUpOnStart}
                                immCard={immCard}
                                immGlobalVariables={immGlobalVariables}
                                immSignaturePattern={immSignaturePattern}
                                immTravelPlus={immTravelPlus}
                                setTravelPlus={setTravelPlus}
                                setCardTravelPlus={setCardTravelPlus}
                                travelPlusReset={travelPlusReset}
                                activated={activated}
                                promotionDate={promotionDate}
                                travelSwitchVisible={travelSwitchVisible}
                                vip={vip}
                                descIntervenciones={descIntervenciones}
                            />
                        </div>
                    );
                }

                if (isEcard || immCard.get('isOpenYoung')) {
                    if (onState) {
                        const chargeLink = `/myprofile/cards/${cardId}/charge`;
                        chargeButton = (
                            <div className="cards-box-header__charge-button">
                                <OKButton
                                    className="card-box-header__active-button"
                                    modifier="secondary"
                                    size="small"
                                    to={chargeLink}
                                >
                                    <FormattedText value="cards-charge" className="card-box-header__active-button" />
                                </OKButton>
                            </div>
                        );
                    } else {
                        const disbledChargeButton = (
                            <div className="cards-box-header__charge-button">
                                <OKButton id={'btnCardsCharge'} disabled={true}>
                                    <FormattedText value="cards-charge" />
                                </OKButton>
                            </div>
                        );
                        chargeButton = (
                            <OKTooltip
                                content="cards-chargeTooltip"
                                offset={[0, -15]}
                                target={disbledChargeButton}
                            />
                        );
                    }
                }
            }
        }

        const infoSectionClass = classnames(
            'cards-box-header__card-section-left',
            {
                'cards-box-header__card-section-left--activate': activateButton,
                'cards-box-header__card-section-left--charge': chargeButton,
                'cards-box-header__card-section-left--control': controlButton && !chargeButton
            }
        );

        const cardsBoxHeaderControlsClassName = contactCenterClassName('cards-box-header__controls', 'cards-box-header__card-section-right pull-right')
        const buttonsSection = (
            <div ref={this.buttonRef}
                className={cardsBoxHeaderControlsClassName}>
                {activateButton}
            </div>
        );
        const tagContent = `interventionTypes-${immCard.get('interventionType')}`;
        const headerTagContent = composeHeaderTag();
        const tagsSection = (
            <div className="ok-header-tag__wrapper">
                <div className="cards-box-header__ok-tag">
                    <OKTag
                        content={tagContent}
                        context="arrow"
                    />
                </div>
                {headerTagContent}
                <WebappRender>
                    <div className="cards-box-header__ok-tag">{headerTag}</div>
                </WebappRender>
                <ContactCenterRender>
                    <div className="cards-box-header__ok-tag">{headerTag}</div>
                </ContactCenterRender>
            </div>
        );

        if (immCard.get('hasBeneficiares') || immCard.get('interventionType') !== CARD_INTERVENTION_OWNER) {
            iconBeneficiaries = (<i className="icon-s-beneficiarios cards-box-header__icon-beneficiaries" />);
        }

        if (__CONTACT_CENTER__) {
            iconBeneficiaries = <i className="icon-s-beneficiarios cards-box-header__icon-beneficiaries"></i>
            iconBeneficiaries = (
                <OKTooltip
                    target={iconBeneficiaries}
                    content={immCard.get('beneficiaryNameOnCard')}
                />
            );
        }

        const paramsCC = __CONTACT_CENTER__ ? [expanded, cardNumber, iconBeneficiaries, brandTranslationKey] : null;
        //const cardsBoxHeaderSub0ClassName = contactCenterClassName('row cards-box-header__subdivision0','');
        const cardsBoxHeaderSub1ClassName = contactCenterClassName('row cards-box-header__subdivision1', '');
        if (expanded || __CONTACT_CENTER__) {
            cardsBoxHeaderView = (
                <div className="cards-box-header" id={'cards-box-header' + cardIndex}>
                    <div className="cards-box-header__actions-container">
                        {cardTitle}
                        <div className="cards-box-header__actions-container-buttons">
                            {switchCardButton}
                            {travelButton}
                            {changePinButton}
                            {controlButton}
                            {chargeButton}
                            {buttonsSection}
                        </div>
                    </div>
                    <div className={cardsBoxHeaderSub1ClassName}>
                        {cardLogoAndBrand}
                        <div className="cards-box-header__info-container cards-box-header__info-container--expanded">
                            <div style={{ '--client-width-btn': this.getButtonAreaClientWidth() + 'px' }}
                                className={infoSectionClass}>
                                {cardTypeSpan}
                                {tagsSection}
                                <WebappRender>
                                    {balanceContent}
                                </WebappRender>
                                <ContactCenterRender>
                                    {this.ccSubdivision3(...paramsCC)}
                                </ContactCenterRender>
                            </div>
                            {buttonsSection}
                        </div>
                    </div>
                    <ContactCenterRender>
                        {balanceContent}
                    </ContactCenterRender>
                </div>
            );
        } else {
            cardsBoxHeaderView = (
                <div className="cards-box-header" id={'cards-box-header' + cardIndex}>
                    <div className="cards-box-header__actions-container">
                        {cardTitle}
                        <div className="cards-box-header__actions-container-buttons">
                            {switchCardButton}
                            {travelButton}
                            {changePinButton}
                            {controlButton}
                            {chargeButton}
                            {buttonsSection}
                        </div>
                    </div>
                    <div className={cardsBoxHeaderSub1ClassName}>
                        {cardLogoAndBrand}
                        <div className="cards-box-header__info-container cards-box-header__info-container--collapsed">
                            <div style={{ '--client-width-btn': this.getButtonAreaClientWidth() + 'px' }}
                                className={infoSectionClass}>
                                {cardTypeSpan}
                                <WebappRender>
                                    {cardNumber}
                                    {iconBeneficiaries}
                                </WebappRender>
                                {tagsSection}
                                {!isCreditCard && balanceContent}
                            </div>
                        </div>
                    </div>
                    {isCreditCard && balanceContent}
                </div>
            );
        }

        return cardsBoxHeaderView;
    }
}


CardsBoxHeader.contextTypes = {
    router: PropTypes.object.isRequired
};

CardsBoxHeader.propTypes = {
    cardIndex: PropTypes.number,
    expanded: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    hireTravelPlusCCWrapUpOffStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    immCard: PropTypes.object,
    immCommercialAds: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    setCardTravelPlus: PropTypes.func.isRequired,
    setTravelPlus: PropTypes.func.isRequired,
    travelPlusReset: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    flagBasedFeatures: state.flagBasedFeatures,
    immGlobalVariables: state.globalVariables,
    immSignaturePattern: state.signaturePattern,
    immTravelPlus: state.hireTravelPlus,
    immVariables: state.globalVariables.getIn(['variables', 'parameters']),
});

const mapDispatchToProps = ({
    hireTravelPlusCCWrapUpOffStart: hireTravelPlusActions.hireTravelPlusCCWrapUpOffStart,
    hireTravelPlusCCWrapUpOnStart: hireTravelPlusActions.hireTravelPlusCCWrapUpOnStart,
    setCardTravelPlus: switchTravelPlusActions.setCardTravelPlus,
    setTravelPlus: hireTravelPlusActions.setTravelPlusWithSignaturePattern,
    travelPlusReset: hireTravelPlusActions.reset,
});

module.exports.constructor = CardsBoxHeader;
module.exports.CardsBoxHeader = connect(mapStateToProps, mapDispatchToProps)(CardsBoxHeader);
